import $http from "../../../axios-instance";
import Swal from "sweetalert2";
import store from "../../../store/store";
const moment = require("moment");

// Nivel
export async function crearNivel({ commit, state, dispatch }, id) {
    commit("dashboard/load", true, { root: true });
    state.selectedNivel.slq_company_id = id;
    state.selectedNivel.active = true;
    await $http
        .post(`company/location-level/create`, state.selectedNivel)
        .then(async response => {
            commit("establecerModalNiveles", false);
            commit("resetSelectedNivel");
            commit("resetFiltroNiveles");
            await dispatch("listLevels");
            await dispatch("listarNivelActivos");

            commit("dashboard/load", false, { root: true });
            await Swal.fire({
                position: "center",
                icon: "success",
                title: "Muy bien!",
                text: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function updateNivel({ commit, state, dispatch }, id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .put(`company/location-level/update/${id}`, state.selectedNivel)
        .then(async response => {
            commit("establecerModalNiveles", false);
            commit("resetSelectedNivel");
            commit("resetFiltroNiveles");
            await dispatch("listLevels");
            await dispatch("listarNivelActivos");

            commit("dashboard/load", false, { root: true });
            await Swal.fire({
                position: "center",
                icon: "success",
                title: "Muy bien!",
                text: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch(error => {
            let message = null;
            if (error.message.level) {
                message = error.message.level[0];
            }
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function deleteNivel({ commit, state, dispatch }, id) {
    let active = null;
    state.selectedNivel.active ? (active = 0) : (active = 1);
    state.selectedNivel.active = active;

    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado del nivel?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si"
    }).then(async result => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });

            await $http
                .put(`company/location-level/update/${id}`, state.selectedNivel)
                .then(async response => {
                    commit("resetSelectedNivel");
                    commit("resetFiltroNiveles");
                    await dispatch("listLevels");
                    await dispatch("listarNivelActivos");

                    commit("dashboard/load", false, { root: true });

                    await Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Muy bien!",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });
                })
                .catch(error => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

export async function listLevels({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    let levels = [];
    let search = null;
    state.filtro_niveles.description
        ? (search = state.filtro_niveles.description)
        : (search = "");
    await $http
        .get(`company/location-level/list/${id_empresa}?search=${search}`)
        .then(response => {
            response.data.data.forEach(element => {
                element.created_at = moment(element.created_at).format(
                    "YYYY-MM-DD"
                );
                levels.push(element);
            });
            commit("setNiveles", levels);
            commit("dashboard/load", false, { root: true });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function listarNivelActivos({ commit, state, rootState }) {
    commit("dashboard/load", true, { root: true });
    const id_empresa = rootState.empresa.selectedEmpresa.id;

    await $http
        .get(`company/location-level/list-active/${id_empresa}`)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setNivelesActivos", response.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

// Ubicaciones
export async function listarUbicaciones({ state, commit, rootState }) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });

    await $http
        .get(
            `company/location/list/${id_empresa}?search=${state.filtro.ubicacion}&page=${state.filtro.page}&perPage=${state.filtro.perPage}`
        )
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setUbicaciones", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function listLocationsActive({ state, commit, rootState }) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(
            `company/location/list-active/${id_empresa}`
        );

        commit("dashboard/load", false, { root: true });
        commit("setLocationActive", response.data.data);
    } catch (error) {
        commit("dashboard/load", false, { root: true });
        Swal.fire({
            position: "center",
            icon: "error",
            title: error.message + "<br> " + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit("accionError", error.message);
    }
}

export async function verListaUbicaciones(
    { state, commit, rootState },
    requestParameters = { params: state.ubicacionAsig }
) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });

    await $http
        .get(`empresas/ver-ubicaciones/${id_empresa}`, requestParameters)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setUbicacionesEmpresa", response.data.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function crearUbicacion({ commit, state, rootState }) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    state.selectedUbicacion.slq_company_id = id_empresa;
    commit("dashboard/load", true, { root: true });

    await $http
        .post(`company/location/create`, state.selectedUbicacion)
        .then(async response => {
            await listarUbicaciones({ commit, state, rootState });
            await arbolUbicacionesEmpresa({ commit, state, rootState });
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Muy bien!",
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            if (state.moduleCreated != "locations") {
                commit("setNewLocation", response.data.data);
            }
            commit("resetSelectedUbicacion");
            commit("dashboard/load", false, { root: true });
            state.errorUbic = false;
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
            state.errorUbic = false;
        });
}

export async function updateUbicacion({ commit, state, dispatch, rootState }) {
    const id_company = rootState.empresa.selectedEmpresa.id;
    state.selectedUbicacion.slq_company_id = id_company;

    commit("dashboard/load", true, { root: true });

    await $http
        .put(
            `company/location/update/${state.selectedUbicacion.id}`,
            state.selectedUbicacion
        )
        .then(async response => {
            await dispatch("listarUbicaciones");
            await dispatch("arbolUbicacionesEmpresa");
            commit("resetSelectedUbicacion");

            commit("dashboard/load", false, { root: true });

            await Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        })
        .catch(error => {
            commit("resetSelectedUbicacion");
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function deleteUbicacion(
    { commit, state, dispatch, rootState },
    id
) {
    let active = null;
    state.selectedUbicacion.active ? (active = 0) : (active = 1);
    state.selectedUbicacion.active = active;
    const id_company = rootState.empresa.selectedEmpresa.id;
    state.selectedUbicacion.slq_company_id = id_company;

    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado de la ubicación?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si"
    }).then(async result => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });

            await $http
                .put(
                    `company/location/update/${state.selectedUbicacion.id}`,
                    state.selectedUbicacion
                )
                .then(async response => {
                    await dispatch("listarUbicaciones");
                    await dispatch("arbolUbicacionesEmpresa");
                    commit("resetSelectedUbicacion");

                    commit("dashboard/load", false, { root: true });

                    await Swal.fire({
                        position: "center",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                })
                .catch(error => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

export async function inactiveLocation(
    { commit, state, rootState, dispatch },
    id
) {
    const reuqest = { slq_company_id: rootState.empresa.selectedEmpresa.id };

    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado de la ubicación?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si"
    }).then(async result => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });

            await $http
                .put(`company/location/inactive/${id}`, reuqest)
                .then(async response => {
                    await dispatch("listarUbicaciones");
                    await dispatch("arbolUbicacionesEmpresa");

                    commit("dashboard/load", false, { root: true });
                    await Swal.fire({
                        position: "center",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                })
                .catch(error => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                });
        }
    });
}

// Ubicacion Empresa
export async function arbolUbicacionesEmpresa(
    { commit, rootState },
    id = null
) {
    let id_empresa = null;
    if (id) {
        id_empresa = id;
    } else {
        id_empresa = rootState.empresa.selectedEmpresa.id;
    }
    commit("dashboard/load", true, { root: true });

    await $http
        .get(`company/location/tree/${id_empresa}`)
        .then(response => {
            commit("dashboard/load", false, { root: true });
            commit("setArbolEmpresa", response.data);
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function listarUbicacionesEmpresa(
    { commit, state },
    id,
    requestParameters = { params: state.ubicacionAsig }
) {
    await $http
        .get(`empresas/ubicaciones/conectadas/${id}`, requestParameters)
        .then(response => {
            commit("setUbicacionesEmpresa", response.data.data);
        })
        .catch(error => {
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function verUbicacionesEmpresa(
    { commit, state },
    id,
    requestParameters = { params: state.ubicacionParent }
) {
    await $http
        .get(`empresas/ubicaciones/ver-conectada/${id}`, requestParameters)
        .then(response => {
            commit("setUbicacionesPadre", response.data.data);
        })
        .catch(error => {
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit("accionError", error.message);
        });
}

export async function crearUbicacionEmpresa({ commit, state, rootState }) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });

    await $http
        .post(
            `empresas/ubicaciones/crear-conectadas/${id_empresa}`,
            state.selectedUbicacionEmpresa
        )
        .then(async response => {
            commit("dashboard/load", false, { root: true });
            await Swal.fire({
                position: "center",
                icon: "success",
                title: "Muy bien!",
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

export async function eliminarUbicacionEmpresa(
    { commit, state, rootState, dispatch },
    { node, data }
) {
    let hijosUbicacionPadre = node.parent.childNodes.length;
    if (
        hijosUbicacionPadre > 1 ||
        node.level == 1 ||
        node.parent.parent.parent
    ) {
        await Swal.fire({
            title: "Cambiar estado",
            text:
                "¿Está seguro de cambiar el estado de la ubicación generales?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Si"
        }).then(async result => {
            if (result.value) {
                commit("setUbicacionEmpresa", data);
                await dispatch("_eliminarUbicacionEmpresa");

                if (state.ubicacionProductos.length) {
                    await Swal.fire({
                        title: "¿Desea continuar?",
                        text: state.ubicacionProductos,
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si, Eliminar"
                    }).then(async result => {
                        if (result.value) {
                            commit("setConfirmarEliminado", {
                                confirmarEliminado: true
                            });
                            commit("dashboard/load", true, { root: true });
                            await dispatch("_eliminarUbicacionEmpresa");
                        }
                    });
                }
            }
        });
    } else {
        await Swal.fire({
            position: "center",
            icon: "warning",
            title: "Advertencia",
            text: "La ubicación hija no puede ser eliminada",
            showConfirmButton: true,
            timer: 2000
        });
    }
}

export async function _eliminarUbicacionEmpresa({
    commit,
    state,
    rootState,
    dispatch
}) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });

    await $http
        .put(
            `empresas/ubicaciones/estado-conectadas/${id_empresa}`,
            state.selectedUbicacionEmpresa
        )
        .then(async response => {
            dispatch("arbolUbicacionesEmpresa");
            commit("dashboard/load", false, { root: true });
            if (!response.data.errors) {
                await Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Muy bien!",
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                });
                state.ubicacionProductos = "";
            } else {
                state.ubicacionProductos = response.data.errors;
            }
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Error",
                text: error.message + "<br> " + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

// filtro de paginacion
export function setPagePagination({ commit, dispatch, rootState }, page) {
    commit("setPage", parseInt(page));
    dispatch("listarUbicaciones", rootState.empresa.selectedEmpresa.id);
}

export async function getTemporaryLocations({ commit, state, rootState }) {
    const id_empresa = rootState.empresa.selectedEmpresa.id;
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(
            `temporary-location/list?company_id=${id_empresa}`
        );
        commit("dashboard/load", false, { root: true });
        commit("setTemporaryLocations", response.data.data);
    } catch (error) {
        commit("dashboard/load", false, { root: true });
        Swal.fire({
            position: "center",
            icon: "error",
            title: error.message + "<br> " + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit("accionError", error.message);
    }
}

export async function confirmTemporaryLocation(
    { commit, state, rootState },
    data
) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post(`temporary-location/confirm`, data);
        commit("dashboard/load", false, { root: true });
        await Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: true,
            timer: 3000
        });
        commit("setModuleCreated", "locations");
        commit("setNewLocation", null);
        console.log(response.data);
    } catch (error) {
        commit("dashboard/load", false, { root: true });
        Swal.fire({
            position: "center",
            icon: "error",
            title: error.message + "<br> " + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit("accionError", error.message);
    }
}
